import { createAsyncThunk } from '@reduxjs/toolkit';
import { getManagerListByCompanyIdApi } from '@src/api';

export const getManagerListByCompanyId = createAsyncThunk(
  'company/getManagerListByCompanyId',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getManagerListByCompanyIdApi(id);
      return response.result.data;
    } catch (err) {
      throw rejectWithValue(err);
    }
  }
);
